import { Text, TouchableOpacity, View } from 'react-native'
import { Ionicons } from '@expo/vector-icons'

// styles
import { colorPalette, globalStyles } from '../../../static/styles/global'

interface oneColumnDisplayProps {
  title: string
  description: string
  visibility?: boolean
  gap?: number
}

const OneColumnDisplay = ({
  title,
  description,
  visibility,
  gap = 0
}: oneColumnDisplayProps): JSX.Element => {
  return (
    <View
      style={[
        globalStyles.hDirection,
        globalStyles.hBetweenItems,
        { marginBottom: gap }
      ]}
    >
      <View style={[globalStyles.colFull]}>
        <Text
          style={[
            globalStyles.text,
            globalStyles.primaryTextColor,
            globalStyles.fwSemiBold,
            globalStyles.mb1
          ]}
        >
          {title}
        </Text>
        <View style={[globalStyles.ml2, globalStyles.hDirection]}>
          <Text style={[globalStyles.text, globalStyles.grayTextColor]}>
            {description}
          </Text>
          {visibility && (
            <TouchableOpacity
              onPress={() => {}}
              style={[
                globalStyles.relativePosition,
                globalStyles.tn2,
                globalStyles.ml2
              ]}
            >
              <Ionicons
                name="eye-outline"
                size={24}
                color={colorPalette.secondary}
              />
            </TouchableOpacity>
          )}
        </View>
      </View>
    </View>
  )
}

export default OneColumnDisplay
